export class LoadingStatus {}

LoadingStatus.NOT_LOADED = 'not-loaded'
LoadingStatus.LOADING = 'loading'
LoadingStatus.ERROR_LOADING = 'error-loading'
LoadingStatus.LOADED = 'loaded'
